import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('instituciones'), { params: opciones.params });
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIPagos(`instituciones/${id}`));
  },
};
